import apiBaseState from "~/constants/apiBaseState";
import Vueset from "~/utils/Vueset";

const getState = () => ({
    taskSequencesForProjectState: apiBaseState(),
    createTaskSequencesForProjectState: apiBaseState(),
    deleteTaskSequencesForProjectState: apiBaseState(),
    updateTaskSequencesForProjectState: apiBaseState(),
    updateTaskSequencesGroupNameState: apiBaseState(),
    tasksState: apiBaseState(),
});

export const state = () => (getState());

export const mutations = {
    RESET_STORE(state){
        const s = getState();
        Object.keys(s).forEach(key => {
            state[key] = s[key];
        });
    },
    SET_UPDATE_TASK_SEQUENCE_GROUP_NAME(state, payload){
        state.updateTaskSequencesGroupNameState = payload;
    },
    SET_GET_TASK_SEQUENCES_FOR_PROJECT(state, payload){
        state.taskSequencesForProjectState = payload;
    },
    SET_DELETE_TASK_SEQUENCE_FOR_PROJECT(state, payload){
        state.deleteTaskSequencesForProjectState = payload;
    },
    SET_UPDATE_TASK_SEQUENCE_FOR_PROJECT(state, payload){
        state.updateTaskSequencesForProjectState = payload;
    },
    SET_GET_TASKS(state, payload){
        state.tasksState = payload;
    },
    UPDATE_TASK_BY_ID(state, payload){
        const index = state.tasksState.data.findIndex(task => task.id === payload.id);
        if(index > -1){
            Vueset(state.tasksState.data, index, payload);
        }
    },
    SET_CREATE_TASK_SEQUENCES_FOR_PROJECT(state, payload){
        state.createTaskSequencesForProjectState = payload;
    },
    PUSH_GROUP_ONTO_TASK_SEQUENCES_FOR_PROJECT(state, payload){
        state.taskSequencesForProjectState.data.push({
            ...payload,
            columns: [
                {
                    must_complete_all: false,
                    tasks: []
                }
            ]
        });
    },
    DELETE_GROUP_BY_ID(state, id){
        const index = state.taskSequencesForProjectState.data.findIndex(group => group.id === id);
        if(index > -1){
            state.taskSequencesForProjectState.data.splice(index ,1);
        }
    }
};

export const actions = {
    GET_TASK_SEQUENCES_FOR_PROJECT(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/task-sequences/groups`;

        return this.$whyApi.get({
            url,
            data: payload,
            mutation: "taskSequencing/SET_GET_TASK_SEQUENCES_FOR_PROJECT",
            errorMessage: "Error getting project data",
            notify: this.$notify
        });
    },
    DELETE_TASK_SEQUENCE_FOR_PROJECT(state, data) {
        const {accountSlug, projectSlug, id} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/task-sequences/groups/${id}`;

        return this.$whyApi.delete({
            url,
            mutation: "taskSequencing/SET_DELETE_TASK_SEQUENCE_FOR_PROJECT",
            errorMessage: "Error deleting project data",
            notify: this.$notify
        });
    },
    UPDATE_TASK_SEQUENCE_FOR_PROJECT(state, data) {
        const {accountSlug, projectSlug, id, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/task-sequences/groups/${id}`;

        return this.$whyApi.put({
            url,
            data: payload,
            mutation: "taskSequencing/SET_UPDATE_TASK_SEQUENCE_FOR_PROJECT",
            errorMessage: "Error updating task sequence",
            notify: this.$notify
        });
    },
    CREATE_TASK_SEQUENCES_FOR_PROJECT(state, data) {
        const {accountSlug, projectSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/task-sequences/groups`;

        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "taskSequencing/SET_CREATE_TASK_SEQUENCES_FOR_PROJECT",
            errorMessage: "Error creating task sequence group",
            notify: this.$notify
        });
    },
    GET_TASKS(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/task-sequences/available-tasks`;

        return this.$whyApi.get({
            url,
            data: payload,
            mutation: "taskSequencing/SET_GET_TASKS",
            errorMessage: "Error getting project data",
            notify: this.$notify
        });
    },
    UPDATE_TASK_SEQUENCE_GROUP_NAME(state, data) {
        const {accountSlug, projectSlug, taskSlug, id, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/task-sequences/groups/${id}/update-name`;

        return this.$whyApi.put({
            url,
            data: payload,
            mutation: "taskSequencing/SET_UPDATE_TASK_SEQUENCE_GROUP_NAME",
            errorMessage: "Error updating group name",
            notify: this.$notify
        });
    },
};
